var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 16.6667C7.19444 16.6667 6.11806 16.4479 5.10417 16.0104C4.09028 15.5729 3.20486 14.9757 2.44792 14.2188C1.69097 13.4618 1.09375 12.5764 0.65625 11.5625C0.21875 10.5486 0 9.46875 0 8.32292C0 7.17708 0.21875 6.10069 0.65625 5.09375C1.09375 4.08681 1.69097 3.20486 2.44792 2.44792C3.20486 1.69097 4.09028 1.09375 5.10417 0.65625C6.11806 0.21875 7.19444 0 8.33333 0C9.08333 0 9.8125 0.0972222 10.5208 0.291667C11.2292 0.486111 11.8889 0.763889 12.5 1.125C11.2361 1.86111 10.2257 2.85764 9.46875 4.11458C8.71181 5.37153 8.33333 6.77778 8.33333 8.33333C8.33333 9.88889 8.71181 11.2951 9.46875 12.5521C10.2257 13.809 11.2361 14.8056 12.5 15.5417C11.8889 15.9028 11.2292 16.1806 10.5208 16.375C9.8125 16.5694 9.08333 16.6667 8.33333 16.6667Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer2);
export default __webpack_public_path__ + "static/media/Container (2).41014cd7bdcdc2eec2acd734a900c92d.svg";
export { ForwardRef as ReactComponent };